module.exports = __webpack_public_path__ + "static/media/objects_07.293c0b56.svg";